/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface ConditionalLinkToArgs {
  condition: boolean;
  route: string;
  disabled?: boolean;
  model?: any;
  models?: any[];
  query?: any;
  replace?: boolean;
  bubbles?: boolean;
}

class ConditionalLinkTo extends Component<ConditionalLinkToArgs> {
  get bubbles() {
    return this.args.bubbles ?? true;
  }

  get condition() {
    return this.args.condition ?? false;
  }

  get models() {
    if (this.args.model) {
      return [this.args.model];
    } else if (this.args.models) {
      return this.args.models;
    }

    return [];
  }
}

export default ConditionalLinkTo;
